import { Button, Card, Description, DescriptionItem, Divider, Notification, Row, Spacer } from '@app/components'
import { InfoCircleOutlined } from '@app/components/icons'
import { toCurrency } from '@app/utils'
import useUnlock from 'libs/services/hooks/useUnlock'
import React, { useState } from 'react'

export const UnlockSummary: React.FC<{
  wallet: string
  unlockingTokens: number
  setUnlockingTokens: (value: number) => void
  lockedWait: number
  currentDiscount: number
  newDiscount: number
  asset: any
  chain: number
  title: string
}> = ({ wallet, unlockingTokens, setUnlockingTokens, lockedWait, currentDiscount, newDiscount, chain, title }) => {
  const [videoOpen, setVideoOpen] = useState(false)

  const descriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
  }
  const after = () => {
    setUnlockingTokens(0)
    Notification({ message: 'Unlock Successful!', type: 'success' })
  }
  const unlock = useUnlock(unlockingTokens * 10 ** 8, after)
  const unlockTokens = () => {
    unlock.write()
  }

  return (
    <>
      <Card>
        <Description
          title={
            <Row align="middle" gutter={0}>
              <span>Fee Summary</span>
              <Button type="text" size="small" onClick={() => setVideoOpen(true)}>
                <InfoCircleOutlined size={20} />
              </Button>
            </Row>
          }
          column={1}
        >
          <DescriptionItem label={'Wallet'} contentStyle={descriptionItemStyle}>
            {wallet}
          </DescriptionItem>
          <DescriptionItem label={'Locked tokens'} contentStyle={descriptionItemStyle}>
            {toCurrency(lockedWait, false)}
          </DescriptionItem>
          <DescriptionItem label={'Unlocking tokens'} contentStyle={descriptionItemStyle}>
            {toCurrency(unlockingTokens * (1 - unlockFee), false)}
          </DescriptionItem>
          <DescriptionItem label={'Burn tokens'} contentStyle={descriptionItemStyle}>
            {toCurrency(unlockingTokens * unlockFee, false)}
          </DescriptionItem>
        </Description>

        <Divider />

        <Description column={1}>
          <DescriptionItem label="New Locked" contentStyle={descriptionItemStyle}>
            {toCurrency(lockedWait - unlockingTokens, false)}
          </DescriptionItem>
          <DescriptionItem label={chain == 1 ? 'Current Tier' : 'Current Tier'} contentStyle={descriptionItemStyle}>
            {currentDiscount}
          </DescriptionItem>
          <DescriptionItem label={chain == 1 ? 'New Tier' : 'New Tier'} contentStyle={descriptionItemStyle}>
            {newDiscount}
          </DescriptionItem>
        </Description>
        <Spacer />
        <Button
          block
          onClick={() => unlockTokens()}
          loading={unlock.state == 'loading'}
          disabled={unlock.state == 'loading' || unlockingTokens == 0}
        >
          Unlock {toCurrency(unlockingTokens * (1 - unlockFee), false)} {title}
        </Button>
      </Card>

      {videoOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
          onClick={() => setVideoOpen(false)}
        >
          <div
            style={{
              position: 'relative',
              width: '80%',
              maxWidth: '800px',
              background: '#fff',
              borderRadius: 8,
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setVideoOpen(false)}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'transparent',
                border: 'none',
                fontSize: 24,
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <iframe
              width="100%"
              height="450"
              src={'https://www.youtube.com/embed/yA39wXcisIk?si=4XMK-9Me0lKjQv20'}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  )
}

const unlockFee = 0.05
